/**
 * Текущий раздел.
 *
 * Через адресную строку, а не через состояние в памяти. Разница
 * заметна ровно там, где человек её ждёт: «назад» в браузере
 * возвращает на прошлый раздел, вкладка переживает перезагрузку, а
 * ссылкой на график можно поделиться.
 *
 * Хеш, а не путь: терминал раздаётся статикой, и обычные пути
 * потребовали бы от сервера отдавать `index.html` на каждый адрес —
 * настройки, которой у статики может не быть.
 */

import { useEffect, useState } from 'react';
import { DEFAULT_SECTION, findSection } from './sections.js';

function fromHash(): string {
  const raw = window.location.hash.replace(/^#\/?/, '');
  // Неизвестный раздел ведёт на главную, а не в пустоту: адрес мог
  // остаться от версии, где такой раздел был.
  return findSection(raw) ? raw : DEFAULT_SECTION;
}

export function useRoute(): [string, (id: string) => void] {
  const [id, setId] = useState(fromHash);

  useEffect(() => {
    const onHash = (): void => setId(fromHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const go = (next: string): void => {
    /*
     * Адрес меняется, а состояние — по событию.
     *
     * Записать и то и другое значило бы два источника правды: нажатие
     * в меню шло бы одним путём, а «назад» в браузере — другим, и
     * однажды они разошлись бы.
     */
    window.location.hash = `#/${next}`;
  };

  return [id, go];
}

/** Проставить адрес, если его нет: после входа человек должен куда-то попасть. */
export function ensureRoute(): void {
  if (window.location.hash.replace(/^#\/?/, '') === '') {
    window.location.hash = `#/${DEFAULT_SECTION}`;
  }
}
